<template>
  <v-dialog v-model=show :width=width persistent>
    <v-card>
      <div class="dialog-base-header">
        <div class="title">
          {{ title }}
        </div>
        <v-spacer/>
        <div class="action">
          <v-icon color="#8B8FA3" class="btn-close" size="16" @click="onClose">mdi-close</v-icon>
        </div>
      </div>
      <slot name="content"></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogBaseWhite",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "420"
    },
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    onClose() {
      this.$emit('on-close')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/dialog-base-white";
</style>
